// import '../../node_modules/lazysizes/lazysizes';
import './components/toggle-nav';
import Swiper, { EffectFade, Autoplay, Pagination } from 'swiper';
import Flickity from 'flickity';
//import Headroom from 'headroom.js';
import { gsap, ScrollTrigger } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger);

// const header = document.querySelector('#masthead');
// const headroom = new Headroom(header);
// headroom.init();

var elem = document.querySelector('.main-carousel');
var flkty = new Flickity(elem, {
  // options
  cellAlign: 'left',
  contain: true,
});

const navButtons = document.querySelectorAll('.nav-button');

navButtons &&
  navButtons.forEach((navButton) => {
    navButton.addEventListener('click', (e) => {
      const activeNavButton = document.querySelector('.nav-button.-active');
      activeNavButton && activeNavButton.classList.remove('-active');
      navButton.classList.add('-active');
    });
  });

ScrollTrigger.create({
  start: 'top -80',
  end: 99999,
  toggleClass: { className: '-scrolled', targets: '#masthead' },
});

let curtains = gsap.utils.toArray('.curtain');

curtains.forEach((curtain, i) => {
  ScrollTrigger.matchMedia({
    '(min-width: 992px)': function () {
      ScrollTrigger.create({
        trigger: curtain,
        start: 'bottom bottom',
        pin: i === curtains.length - 1 ? false : true,
        pinSpacing: false,
      });
    },
  });
});

Swiper.use([EffectFade, Autoplay, Pagination]);
const swiper = new Swiper('.swiper', {
  // effect: 'fade',
  speed: 1000,
  // loop: true,
  // fadeEffect: {
  //   crossFade: true,
  // },
  // autoplay: {
  //   delay: 2000,
  //   pauseOnMouseEnter: true,
  // },
  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },
});

swiper.on('afterInit', ScrollTrigger.refresh());
